$(function() {
  clampTextRelatedArticle();
  $(window).on('load', clampTextRelatedArticle);
  $(window).on('resize', clampTextRelatedArticle);
});
var clampTextRelatedArticleFlag = false
function clampTextRelatedArticle() {
  if (clampTextRelatedArticleFlag) return;

  var el = $('.post-partnership-title');
  if (el.length == 0) {
    clampTextRelatedArticleFlag = true;
    console.log('false')
    return;
  }

  el.each(function() {
    var _t = $(this),
        _t_excerpt = _t.next('.post-partnership-excerpt'),
        line_clamp = false;

    if (_t.outerHeight() >= 80) {
      line_clamp = 3;
    } else if (_t.outerHeight() >= 50) {
      line_clamp = 4;
    }

    if (line_clamp !== false) {
      _t_excerpt.css({
        '-webkit-line-clamp': line_clamp.toString(),
      });
    } else {
      _t_excerpt.removeAttr('style');
    }
  });
}